"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectedOemText = void 0;
exports.selectedOemText = Object.freeze({
    0: "KOT",
    1: "勤革時",
    2: "ToT",
    3: "セコム",
    4: "おまかせ",
    5: "Freee",
    6: "オフィス",
});
